import Com from './inputRow';
export var InputRow = Com.InputRow;
export var SelectRow = Com.SelectRow;
export var RealnameRow = Com.RealnameRow;
export var TelRow = Com.TelRow;
export var MessageCodeRow = Com.MessageCodeRow;
export var RadioRow = Com.RadioRow;
